import React from 'react';

export default function Tool({ skills }) {
    return (
        <div className="flex-column">
            <span className="tool">Tools: { skills }</span>
        </div>
    )
};